import React, { useState, useEffect, useRef } from 'react';
import api from '../../../services/api';
import { 
    Presentation, 
    AlertCircle, 
    HelpCircle, 
    Pencil, 
    X, 
    Search, 
    SlidersHorizontal, 
    Plus, 
    MoreVertical, 
    ChevronLeft, 
    ChevronRight,
    Settings,
    ArrowRight
} from 'lucide-react';
import './PresentationConfig.css';

// ==========================================
// 1. Reusable Vector Schematic Svg Component
// ==========================================
const RenderSchematicSvg = ({ id }) => {
    switch (id) {
        case 'bullets':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <rect x="20" y="20" width="120" height="16" rx="4" fill="#E9471D" fillOpacity="0.1"/>
                    <circle cx="25" cy="55" r="4" fill="#E9471D"/>
                    <rect x="38" y="52" width="150" height="6" rx="3" fill="#e2e8f0"/>
                    <circle cx="25" cy="73" r="4" fill="#E9471D"/>
                    <rect x="38" y="70" width="220" height="6" rx="3" fill="#cbd5e1"/>
                    <circle cx="25" cy="91" r="4" fill="#E9471D"/>
                    <rect x="38" y="88" width="180" height="6" rx="3" fill="#e2e8f0"/>
                    <circle cx="25" cy="109" r="4" fill="#E9471D"/>
                    <rect x="38" y="106" width="120" height="6" rx="3" fill="#cbd5e1"/>
                    <path d="M280 0 L400 0 L400 160 L320 160 Z" fill="#7A220B"/>
                    <rect x="340" y="30" width="30" height="20" rx="3" fill="#ffffff" fillOpacity="0.2"/>
                    <line x1="346" y1="37" x2="364" y2="37" stroke="#ffffff" strokeWidth="2" strokeOpacity="0.8"/>
                    <line x1="346" y1="43" x2="358" y2="43" stroke="#ffffff" strokeWidth="2" strokeOpacity="0.8"/>
                </svg>
            );
        case 'table':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <rect x="20" y="20" width="240" height="16" rx="4" fill="#E9471D" fillOpacity="0.1"/>
                    <rect x="20" y="48" width="360" height="20" rx="3" fill="#7A220B"/>
                    <line x1="120" y1="48" x2="120" y2="68" stroke="#ffffff" strokeOpacity="0.2"/>
                    <line x1="240" y1="48" x2="240" y2="68" stroke="#ffffff" strokeOpacity="0.2"/>
                    <rect x="20" y="74" width="360" height="16" rx="3" fill="#ffffff" stroke="#e2e8f0"/>
                    <rect x="30" y="79" width="60" height="6" rx="2" fill="#cbd5e1"/>
                    <rect x="130" y="79" width="80" height="6" rx="2" fill="#f1f5f9"/>
                    <rect x="20" y="96" width="360" height="16" rx="3" fill="#ffffff" stroke="#e2e8f0"/>
                    <rect x="30" y="101" width="70" height="6" rx="2" fill="#cbd5e1"/>
                    <rect x="130" y="101" width="90" height="6" rx="2" fill="#f1f5f9"/>
                    <rect x="20" y="118" width="360" height="16" rx="3" fill="#ffffff" stroke="#e2e8f0"/>
                    <rect x="30" y="123" width="50" height="6" rx="2" fill="#cbd5e1"/>
                    <rect x="130" y="123" width="70" height="6" rx="2" fill="#f1f5f9"/>
                </svg>
            );
        case 'detailed_journey':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <rect x="20" y="15" width="50" height="12" rx="3" fill="#cbd5e1" fillOpacity="0.4"/>
                    <rect x="80" y="15" width="50" height="12" rx="3" fill="#cbd5e1" fillOpacity="0.4"/>
                    <rect x="140" y="15" width="50" height="12" rx="3" fill="#cbd5e1" fillOpacity="0.4"/>
                    <rect x="200" y="15" width="50" height="12" rx="3" fill="#cbd5e1" fillOpacity="0.4"/>
                    <g transform="translate(10, 40)">
                        <rect x="10" y="10" width="80" height="50" rx="6" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1.5"/>
                        <circle cx="30" cy="30" r="10" fill="#FFF1EC"/>
                        <rect x="25" y="46" width="50" height="6" rx="2" fill="#cbd5e1"/>
                        <rect x="100" y="10" width="80" height="50" rx="6" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1.5"/>
                        <circle cx="120" cy="30" r="10" fill="#FFF1EC"/>
                        <rect x="115" y="46" width="50" height="6" rx="2" fill="#cbd5e1"/>
                        <rect x="190" y="10" width="80" height="50" rx="6" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1.5"/>
                        <circle cx="210" cy="30" r="10" fill="#FFF1EC"/>
                        <rect x="205" y="46" width="50" height="6" rx="2" fill="#cbd5e1"/>
                        <rect x="280" y="10" width="80" height="50" rx="6" fill="#ffffff" stroke="#e2e8f0" strokeWidth="1.5"/>
                        <circle cx="300" cy="30" r="10" fill="#FFF1EC"/>
                        <rect x="295" y="46" width="50" height="6" rx="2" fill="#cbd5e1"/>
                    </g>
                </svg>
            );
        case 'journey':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <line x1="50" y1="70" x2="350" y2="70" stroke="#cbd5e1" strokeWidth="4"/>
                    <circle cx="70" cy="70" r="16" fill="#7A220B"/>
                    <text x="70" y="74" textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">01</text>
                    <rect x="40" y="100" width="60" height="8" rx="3" fill="#cbd5e1"/>
                    <rect x="45" y="112" width="50" height="6" rx="2" fill="#f1f5f9"/>
                    <circle cx="160" cy="70" r="16" fill="#7A220B"/>
                    <text x="160" y="74" textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">02</text>
                    <rect x="130" y="100" width="60" height="8" rx="3" fill="#cbd5e1"/>
                    <rect x="135" y="112" width="50" height="6" rx="2" fill="#f1f5f9"/>
                    <circle cx="250" cy="70" r="16" fill="#7A220B"/>
                    <text x="250" y="74" textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">03</text>
                    <rect x="220" y="100" width="60" height="8" rx="3" fill="#cbd5e1"/>
                    <rect x="225" y="112" width="50" height="6" rx="2" fill="#f1f5f9"/>
                    <circle cx="330" cy="70" r="16" fill="#7A220B"/>
                    <text x="330" y="74" textAnchor="middle" fill="#ffffff" fontSize="10" fontWeight="bold">04</text>
                    <rect x="300" y="100" width="60" height="8" rx="3" fill="#cbd5e1"/>
                    <rect x="305" y="112" width="50" height="6" rx="2" fill="#f1f5f9"/>
                </svg>
            );
        case 'timeline':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <path d="M 40 90 Q 120 30, 200 90 T 360 90" fill="none" stroke="#E9471D" strokeWidth="4"/>
                    <circle cx="80" cy="68" r="8" fill="#ffffff" stroke="#E9471D" strokeWidth="3"/>
                    <circle cx="200" cy="90" r="8" fill="#ffffff" stroke="#E9471D" strokeWidth="3"/>
                    <circle cx="320" cy="78" r="8" fill="#ffffff" stroke="#E9471D" strokeWidth="3"/>
                    <rect x="50" y="20" width="60" height="20" rx="4" fill="#334155"/>
                    <polygon points="80,40 76,46 84,46" fill="#334155"/>
                    <rect x="290" y="30" width="60" height="20" rx="4" fill="#334155"/>
                    <polygon points="320,50 316,56 324,56" fill="#334155"/>
                </svg>
            );
        case 'chevron':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <g transform="translate(10, 45)">
                        <path d="M 10 10 L 95 10 L 115 35 L 95 60 L 10 60 L 30 35 Z" fill="#E9471D" fillOpacity="0.1" stroke="#E9471D" strokeWidth="1.5"/>
                        <path d="M 125 10 L 210 10 L 230 35 L 210 60 L 125 60 L 145 35 Z" fill="#10b981" fillOpacity="0.1" stroke="#10b981" strokeWidth="1.5"/>
                        <path d="M 240 10 L 325 10 L 345 35 L 325 60 L 240 60 L 260 35 Z" fill="#f59e0b" fillOpacity="0.1" stroke="#f59e0b" strokeWidth="1.5"/>
                    </g>
                </svg>
            );
        case 'funnel':
        case 'labeled_funnel':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <polygon points="120,20 280,20 250,52 150,52" fill="#E9471D" fillOpacity="0.8"/>
                    <polygon points="152,55 248,55 225,87 175,87" fill="#10b981" fillOpacity="0.8"/>
                    <polygon points="177,90 223,90 210,130 190,130" fill="#f59e0b" fillOpacity="0.8"/>
                </svg>
            );
        case 'cycle':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <circle cx="200" cy="80" r="48" fill="none" stroke="#E9471D" strokeWidth="3" strokeDasharray="24 6"/>
                    <polygon points="248,70 256,85 240,85" fill="#E9471D" transform="rotate(45, 248, 80)"/>
                    <polygon points="152,90 160,75 144,75" fill="#E9471D" transform="rotate(225, 152, 80)"/>
                    <circle cx="200" cy="80" r="16" fill="#7A220B"/>
                </svg>
            );
        case 'matrix':
        case 'detailed_matrix':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <rect x="60" y="20" width="135" height="55" rx="6" fill="#FFF1EC" stroke="#FFD0C2" strokeWidth="2"/>
                    <rect x="205" y="20" width="135" height="55" rx="6" fill="#f0fdf4" stroke="#bbf7d0" strokeWidth="2"/>
                    <rect x="60" y="85" width="135" height="55" rx="6" fill="#fffbeb" stroke="#fef3c7" strokeWidth="2"/>
                    <rect x="205" y="85" width="135" height="55" rx="6" fill="#fdf2f8" stroke="#fbcfe8" strokeWidth="2"/>
                    <text x="127" y="52" textAnchor="middle" fill="#B33010" fontSize="11" fontWeight="bold">01</text>
                    <text x="272" y="52" textAnchor="middle" fill="#166534" fontSize="11" fontWeight="bold">02</text>
                    <text x="127" y="117" textAnchor="middle" fill="#92400e" fontSize="11" fontWeight="bold">03</text>
                    <text x="272" y="117" textAnchor="middle" fill="#9d174d" fontSize="11" fontWeight="bold">04</text>
                </svg>
            );
        case 'venn':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <circle cx="170" cy="80" r="48" fill="#E9471D" fillOpacity="0.25" stroke="#E9471D" strokeWidth="2"/>
                    <circle cx="230" cy="80" r="48" fill="#db2777" fillOpacity="0.25" stroke="#db2777" strokeWidth="2"/>
                    <circle cx="200" cy="110" r="30" fill="#059669" fillOpacity="0.2" stroke="#059669" strokeWidth="2"/>
                </svg>
            );
        case 'pyramid':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <polygon points="200,20 120,140 280,140" fill="none" stroke="#64748b" strokeWidth="2"/>
                    <polygon points="200,20 170,65 230,65" fill="#E9471D" fillOpacity="0.8"/>
                    <polygon points="168,68 232,68 250,105 150,105" fill="#10b981" fillOpacity="0.8"/>
                    <polygon points="148,108 252,108 270,138 130,138" fill="#f59e0b" fillOpacity="0.8"/>
                </svg>
            );
        case 'radial_hub':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <line x1="200" y1="80" x2="110" y2="40" stroke="#cbd5e1" strokeWidth="2"/>
                    <line x1="200" y1="80" x2="290" y2="40" stroke="#cbd5e1" strokeWidth="2"/>
                    <line x1="200" y1="80" x2="110" y2="120" stroke="#cbd5e1" strokeWidth="2"/>
                    <line x1="200" y1="80" x2="290" y2="120" stroke="#cbd5e1" strokeWidth="2"/>
                    <circle cx="200" cy="80" r="24" fill="#7A220B" stroke="#E9471D" strokeWidth="2"/>
                    <circle cx="110" cy="40" r="14" fill="#E9471D"/>
                    <circle cx="290" cy="40" r="14" fill="#10b981"/>
                    <circle cx="110" cy="120" r="14" fill="#f59e0b"/>
                    <circle cx="290" cy="120" r="14" fill="#db2777"/>
                </svg>
            );
        case 'big_number':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <text x="200" y="85" textAnchor="middle" fill="#7A220B" fontSize="56" fontWeight="900">99.9%</text>
                    <text x="200" y="115" textAnchor="middle" fill="#64748b" fontSize="11" fontWeight="bold" letterSpacing="0.05em">ACCURACY RATING</text>
                </svg>
            );
        case 'chart_sidebar':
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <rect x="40" y="110" width="16" height="30" rx="2" fill="#E9471D"/>
                    <rect x="64" y="80" width="16" height="60" rx="2" fill="#7A220B"/>
                    <rect x="88" y="50" width="16" height="90" rx="2" fill="#10b981"/>
                    <rect x="112" y="95" width="16" height="45" rx="2" fill="#f59e0b"/>
                    <rect x="160" y="40" width="200" height="12" rx="3" fill="#475569"/>
                    <rect x="160" y="60" width="160" height="8" rx="2" fill="#94a3b8"/>
                    <rect x="160" y="76" width="180" height="8" rx="2" fill="#94a3b8"/>
                </svg>
            );
        default:
            return (
                <svg viewBox="0 0 400 160" className="schematic-svg">
                    <rect width="400" height="160" fill="#F8F9FA"/>
                    <rect x="40" y="30" width="320" height="100" rx="8" fill="#ffffff" stroke="#cbd5e1" strokeWidth="2" strokeDasharray="4 4"/>
                    <path d="M180 60 L220 60 L200 40 Z" fill="#94a3b8"/>
                    <text x="200" y="95" textAnchor="middle" fill="#64748b" fontSize="12" fontWeight="bold">SLIDE ARCHETYPE LAYOUT</text>
                </svg>
            );
    }
};

// ==================================================
// 2. Reusable Modular Chip: SlideNumberChip
// ==================================================
const SlideNumberChip = ({ numbers }) => {
    if (!numbers || numbers.length === 0) return null;
    return (
        <span className="archetype-slide-badge">
            Slides: {numbers.join(', ')}
        </span>
    );
};

// ==================================================
// 3. Reusable Modular Stats Block: CapacityStats
// ==================================================
const CapacityStats = ({ min, max }) => {
    return (
        <div className="archetype-capacity-row">
            <div className="capacity-metric">
                <div className="capacity-label">Min Capacity</div>
                <div className="capacity-value">{min}</div>
            </div>
            <div className="capacity-metric">
                <div className="capacity-label">Max Capacity</div>
                <div className="capacity-value">{max}</div>
            </div>
        </div>
    );
};

// ==================================================
// 4. Reusable Modular Callout Box: CapacityNote
// ==================================================
const CapacityNote = ({ note, name }) => {
    return (
        <div className="archetype-note-box">
            <div className="archetype-note-title">
                <HelpCircle size={13} fill="#b45309" fillOpacity="0.15" />
                <span>Capacity Note</span>
            </div>
            <div>{note || `Default slide template capacity configured for ${name || 'layout'} rendering.`}</div>
        </div>
    );
};

// ==================================================
// 5. Reusable Card Component: ArchetypeCard
// ==================================================
const ArchetypeCard = ({ 
    arch, 
    onEdit, 
    onSelect, 
    activeDropdownId, 
    setActiveDropdownId, 
    dropdownRef 
}) => {
    return (
        <div className="archetype-card" onClick={() => onSelect(arch)}>
            {/* Card preview visual vector schematic representing the slide type */}
            <div className="archetype-preview-container">
                <RenderSchematicSvg id={arch.id} />
                
                {/* Actions dots triggers options dropdown */}
                <button 
                    className="archetype-card-dots" 
                    onClick={(e) => {
                        e.stopPropagation(); // Stop click from triggering parent select drawer
                        setActiveDropdownId(activeDropdownId === arch.id ? null : arch.id);
                    }}
                >
                    <MoreVertical size={16} />
                </button>

                {/* Option dropdown menu */}
                {activeDropdownId === arch.id && (
                    <div className="ppt-card-dropdown" ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
                        <button className="dropdown-item" onClick={() => onEdit(arch)}>
                            <Pencil size={13} />
                            <span>Edit Guidelines</span>
                        </button>
                    </div>
                )}
            </div>

            <div className="archetype-content">
                {/* Header Row: Title & Badge on same line */}
                <div className="archetype-header-row">
                    <h3 className="archetype-name">{arch.name}</h3>
                    <SlideNumberChip numbers={arch.slide_numbers} />
                </div>

                {/* Clamped Guidelines - exactly 2 lines */}
                <p className="archetype-guidelines" title={arch.usage_guidelines}>
                    {arch.usage_guidelines}
                </p>

                {/* Symmetrical Capacity metrics */}
                <CapacityStats min={arch.min_capacity} max={arch.max_capacity} />

                {/* Capacity Note Callout box */}
                <CapacityNote note={arch.capacity_usage_guideline} name={arch.name} />
            </div>
        </div>
    );
};

// ==================================================
// 6. Premium Right-Side Slide-Over Detail Drawer
// ==================================================
// ==================================================
// 6. Centered Detail Modal (50% Width / 50% Height)
// ==================================================
const ArchetypeDetailModal = ({ 
    arch, 
    isOpen, 
    onClose, 
    onEdit, 
    onConfigure 
}) => {
    if (!isOpen || !arch) return null;

    // Helper to dynamically render variables list of archetype
    const renderVariantsTable = (variants) => {
        if (!variants || variants.length === 0) return <p className="ppt-drawer-text" style={{ color: '#94a3b8' }}>No layout variations configured.</p>;
        const keys = Object.keys(variants[0]);
        return (
            <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                <table className="ppt-variants-table">
                    <thead>
                        <tr>
                            {keys.map(key => (
                                <th key={key}>{key.replace('_', ' ')}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {variants.map((v, i) => (
                            <tr key={i}>
                                {keys.map(key => (
                                    <td key={key}>{v[key]}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className="ppt-detail-modal-overlay" onClick={onClose}>
            <div className="ppt-detail-modal" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="ppt-detail-modal-header">
                    <h2>{arch.name} Overview</h2>
                    <button className="ppt-close-btn" onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>

                {/* Scrollable Body - Completely removed preview visual to keep it spacious and clean */}
                <div className="ppt-detail-modal-scrollable">
                    {/* Metadata Section */}
                    <div>
                        <div className="ppt-drawer-section-title">Archetype Details</div>
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>
                            <SlideNumberChip numbers={arch.slide_numbers} />
                            <span className="ppt-keyword-pill">Min Capacity: {arch.min_capacity}</span>
                            <span className="ppt-keyword-pill">Max Capacity: {arch.max_capacity}</span>
                        </div>
                    </div>

                    {/* Usage guidelines */}
                    <div>
                        <div className="ppt-drawer-section-title">Usage Guidelines</div>
                        <p className="ppt-drawer-text">{arch.usage_guidelines}</p>
                    </div>

                    {/* Capacity Note */}
                    {arch.capacity_usage_guideline && (
                        <div>
                            <div className="ppt-drawer-section-title">Capacity Guideline</div>
                            <p className="ppt-drawer-text" style={{ fontStyle: 'italic', color: '#b45309' }}>
                                {arch.capacity_usage_guideline}
                            </p>
                        </div>
                    )}

                    {/* Variants Table */}
                    <div>
                        <div className="ppt-drawer-section-title">Layout Variations</div>
                        {renderVariantsTable(arch.variants)}
                    </div>

                    {/* Discovery Keywords */}
                    {arch.discovery_keywords && arch.discovery_keywords.length > 0 && (
                        <div>
                            <div className="ppt-drawer-section-title">Discovery Keywords</div>
                            <div className="ppt-keywords-container" style={{ marginTop: '8px' }}>
                                {arch.discovery_keywords.map((kw, i) => (
                                    <span key={i} className="ppt-keyword-pill">#{kw}</span>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer Buttons */}
                <div className="ppt-detail-modal-footer">
                    <button className="ppt-btn-secondary" onClick={onClose}>
                        Close Window
                    </button>
                    <button className="ppt-btn-secondary" style={{ display: 'flex', alignItems: 'center', gap: '6px' }} onClick={() => onConfigure(arch)}>
                        <Settings size={14} />
                        <span>Configure Rules</span>
                    </button>
                    <button className="ppt-btn-primary" onClick={() => onEdit(arch)}>
                        Edit Guidelines
                    </button>
                </div>
            </div>
        </div>
    );
};

// ==================================================
// 7. Main Dashboard Screen: PresentationConfig
// ==================================================
const PresentationConfig = () => {
    const [archetypes, setArchetypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Interactive System states
    const [searchTerm, setSearchTerm] = useState('');
    const [activeDropdownId, setActiveDropdownId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedArchetype, setSelectedArchetype] = useState(null);
    const dropdownRef = useRef(null);

    // Modal Editing states
    const [editingArch, setEditingArch] = useState(null);
    const [newGuidelines, setNewGuidelines] = useState('');
    const [saving, setSaving] = useState(false);
    const [saveError, setSaveError] = useState(null);

    // Fetch API Data
    useEffect(() => {
        const fetchArchetypes = async () => {
            try {
                const response = await api.get('/ppt-config/archetypes');
                if (response.status === 200 || response.data) {
                    setArchetypes(response.data.archetypes || []);
                } else {
                    throw new Error('Failed to fetch presentation archetypes');
                }
            } catch (err) {
                console.error('Error fetching archetypes:', err);
                setError(err.message || 'Something went wrong while loading presentation configurations.');
            } finally {
                setLoading(false);
            }
        };

        fetchArchetypes();
    }, []);

    // Dropdown close listener
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActiveDropdownId(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Filter Query Search
    const filteredArchetypes = archetypes.filter(arch => {
        const matchStr = `${arch.name} ${arch.usage_guidelines} ${(arch.discovery_keywords || []).join(' ')}`.toLowerCase();
        return matchStr.includes(searchTerm.toLowerCase());
    });

    // Pagination metrics (8 items per page)
    const itemsPerPage = 8;
    const totalItems = filteredArchetypes.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    const paginatedItems = filteredArchetypes.slice(startIndex, endIndex);

    const startEditing = (arch) => {
        setEditingArch(arch);
        setNewGuidelines(arch.usage_guidelines || '');
        setSaveError(null);
        setActiveDropdownId(null);
    };

    const handleSave = async () => {
        if (!newGuidelines.trim()) {
            setSaveError('Usage guidelines cannot be empty.');
            return;
        }

        setSaving(true);
        setSaveError(null);
        try {
            const response = await api.put(`/ppt-config/archetypes/${editingArch.name}`, {
                usage_guidelines: newGuidelines
            }, {
                headers: {
                    'id': editingArch.id
                }
            });

            if (response.status === 200 || response.data) {
                setArchetypes(prev => prev.map(a => 
                    a.id === editingArch.id ? { ...a, usage_guidelines: newGuidelines } : a
                ));
                // Update selected archetype if it is being displayed in the active drawer
                if (selectedArchetype && selectedArchetype.id === editingArch.id) {
                    setSelectedArchetype(prev => ({ ...prev, usage_guidelines: newGuidelines }));
                }
                setEditingArch(null);
            } else {
                throw new Error('Failed to update guidelines');
            }
        } catch (err) {
            console.error('Error updating archetype:', err);
            setSaveError(err.message || 'An error occurred while trying to save changes.');
        } finally {
            setSaving(false);
        }
    };

    const handleConfigure = (arch) => {
        alert(`Opened configuration dashboard settings for: ${arch.name}`);
    };

    return (
        <div className="presentation-config-container">
            {/* Header Area */}
            <div className="ppt-header">
                <div className="ppt-header-info">
                    <h1>Presentation Archetypes</h1>
                    <p>Configure dynamic presentation rules and design archetypes for RFP generated slides.</p>
                </div>
                <div className="ppt-header-actions">
                    <button className="ppt-btn-create" onClick={() => alert('Add slide type layout configuration.')}>
                        <Plus size={16} />
                        <span>Create Archetype</span>
                    </button>
                    <button className="ppt-btn-filter">
                        <SlidersHorizontal size={14} />
                        <span>Filter</span>
                    </button>
                    <div className="ppt-search-box">
                        <Search size={16} className="ppt-search-icon" />
                        <input
                            type="text"
                            placeholder="Search archetypes..."
                            className="ppt-search-input"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                    </div>
                </div>
            </div>

            {error && (
                <div style={{
                    background: '#fef2f2',
                    border: '1px solid #fca5a5',
                    color: '#b91c1c',
                    padding: '16px',
                    borderRadius: '8px',
                    marginBottom: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <AlertCircle size={20} />
                    <span>{error}</span>
                </div>
            )}

            {loading ? (
                <div className="archetypes-grid">
                    {[...Array(8)].map((_, i) => (
                        <div key={i} className="archetype-skeleton-card">
                            <div className="skeleton-preview skeleton-shimmer" />
                            <div className="skeleton-body">
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                    <div className="skeleton-title skeleton-shimmer" />
                                    <div className="skeleton-badge skeleton-shimmer" />
                                </div>
                                <div className="skeleton-text-line skeleton-shimmer" style={{ marginBottom: '6px' }} />
                                <div className="skeleton-text-line skeleton-shimmer" style={{ marginBottom: '6px' }} />
                                <div className="skeleton-text-short skeleton-shimmer" />
                                <div style={{ marginTop: 'auto', display: 'flex', gap: '12px' }}>
                                    <div style={{ flex: 1, height: '36px', borderRadius: '6px' }} className="skeleton-shimmer" />
                                    <div style={{ flex: 1, height: '36px', borderRadius: '6px' }} className="skeleton-shimmer" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <>
                    {/* Responsive Grid Layout */}
                    <div className="archetypes-grid">
                        {paginatedItems.map((arch) => (
                            <ArchetypeCard
                                key={arch.id}
                                arch={arch}
                                onSelect={setSelectedArchetype}
                                onEdit={startEditing}
                                activeDropdownId={activeDropdownId}
                                setActiveDropdownId={setActiveDropdownId}
                                dropdownRef={dropdownRef}
                            />
                        ))}
                    </div>

                    {/* Centered Pagination controls */}
                    {totalPages > 1 && (
                        <div className="ppt-pagination-container">
                            <div className="ppt-pagination-info">
                                Showing {startIndex + 1}-{endIndex} of {totalItems}
                            </div>
                            <div className="ppt-pagination-controls">
                                <button 
                                    className="ppt-page-btn" 
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                >
                                    <ChevronLeft size={16} />
                                </button>
                                {[...Array(totalPages)].map((_, i) => (
                                    <button 
                                        key={i} 
                                        className={`ppt-page-btn ${currentPage === i + 1 ? 'active' : ''}`}
                                        onClick={() => setCurrentPage(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                ))}
                                <button 
                                    className="ppt-page-btn" 
                                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                >
                                    <ChevronRight size={16} />
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* Centered details modal (50% Width / 50% Height) */}
            <ArchetypeDetailModal
                arch={selectedArchetype}
                isOpen={!!selectedArchetype}
                onClose={() => setSelectedArchetype(null)}
                onEdit={startEditing}
                onConfigure={handleConfigure}
            />

            {/* Guidelines Edit Popup Modal */}
            {editingArch && (
                <div className="ppt-modal-overlay">
                    <div className="ppt-modal-content">
                        <div className="ppt-modal-header">
                            <h2>Edit {editingArch.name} Guidelines</h2>
                            <button className="ppt-close-btn" onClick={() => setEditingArch(null)} disabled={saving}>
                                <X size={20} />
                            </button>
                        </div>

                        {saveError && (
                            <div style={{
                                background: '#fef2f2',
                                border: '1px solid #fca5a5',
                                color: '#b91c1c',
                                padding: '12px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                fontSize: '14px'
                            }}>
                                <AlertCircle size={18} />
                                <span>{saveError}</span>
                            </div>
                        )}

                        <div className="ppt-form-group">
                            <label htmlFor="modal-textarea">Usage Guidelines</label>
                            <textarea
                                id="modal-textarea"
                                className="ppt-textarea"
                                value={newGuidelines}
                                onChange={(e) => setNewGuidelines(e.target.value)}
                                placeholder="Enter usage guidelines and specific instructions for this slide..."
                                disabled={saving}
                            />
                        </div>

                        <div className="ppt-modal-footer">
                            <button 
                                className="ppt-btn-secondary" 
                                onClick={() => setEditingArch(null)} 
                                disabled={saving}
                            >
                                Cancel
                            </button>
                            <button 
                                className="ppt-btn-primary" 
                                onClick={handleSave} 
                                disabled={saving}
                            >
                                {saving ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PresentationConfig;
